import React from "react";

export function Loading(){
    return (
        <div className="loading">Loading...</div>
    )
}